import * as React from 'react';
import './index.scss';
import { Button, Modal, message, Popover, Input, Select, Spin, Form, Space, TimePicker, InputNumber } from 'antd';
import { DoubleRightOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { addMeetingOrder, updateMeetingOrder } from '../../model/api';
import dateFormat from 'dateformat';
import moment from 'moment';
import { timeMap, standardMap, locationMap } from './constants';

const { confirm } = Modal;

export default class AddMeetingOrder extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    }
  }

  formRef = React.createRef();

  componentDidMount() {
    const { type, editData } = this.props
    if (type === 'edit') {
      this.formRef.current.setFieldsValue({
        time: editData.time,
        reason: editData.reason,
        standard: editData.standard,
        location: editData.location,
        number: editData.number
      });
    }
  }

  // 获取当前时间的小时和分钟
  getCurrentTime = () => {
    const now = moment();
    return {
      hours: now.hours(),
      minutes: now.minutes(),
    };
  }

  // 禁用时间
  disabledTime = (inputHour) => {
    const nowDate = dateFormat(new Date(), 'yyyy-mm-dd')

    if (nowDate === this.props.selectedDate) {// 选择的是今天
      const now = moment();
      const inputTime = moment().hour(inputHour).minute(0).second(0);

      // 当前时间小于传入时间
      if (now.isBefore(inputTime)) {
        const diffInMinutes = inputTime.diff(now, 'minutes');
        if (diffInMinutes < 60) {
          return true;
        } else {
          return false;
        }
      }
      // 当前时间大于或等于传入时间
      return true;
    }
    return false
  };

  // 提交新增
  save = async (data) => {
    try {
      const { type, editData } = this.props
      // console.log("submit data=", data)
      const { reason, date, time, number, standard, location } = data
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const params = {
        userid: user?.id,
        reason,
        date,
        time,
        number,
        expense: standard,
        location,
      }
      if (type === 'edit') {
        params.id = editData?.id
      }
      const res = type === 'edit' ? await updateMeetingOrder(params) : await addMeetingOrder(params)
      if (res.code === 200 || res.code === 0) {
        message.success(type === 'edit' ? '修改会议订餐成功' : '新增会议订餐成功')
        this.props.onClose()
      }
    } catch (err) {
      console.log("err=", err)
    } finally {

    }
  }

  // 提交二次确认
  submit = (values) => {
    // console.log("values=", values)
    const { time, reason, standard, number, location } = values
    const displayTime = this.props.selectedDate + ' ' + timeMap[time]
    confirm({
      title: '请确认会议订餐信息',
      icon: <ExclamationCircleOutlined />,
      centered: true,
      className: 'order-submit-modal',
      width: 320,
      content: <div className='submit-modal-content'>
        <p><span>送餐时间:</span>{displayTime}</p>
        <p><span>订餐事由:</span>{reason}</p>
        <p><span>餐标:</span>{standardMap[standard]}</p>
        <p><span>配送区域:</span>{locationMap[location]}</p>
        <p><span>数量:</span>{number}</p>
      </div>,
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.save({ ...values, date: this.props.selectedDate })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    const { } = this.state;
    const { onClose, type } = this.props
    return (
      <div className='add-meeting-order'>
        <div className='add-header'>
          <div className='add-total'>{type === 'add' ? '新增' : '修改'}会议订餐<span></span></div>
          <div className='add-jump' onClick={onClose}>去查看历史会议订餐 <DoubleRightOutlined style={{ fontSize: 12 }} /></div>
        </div>
        <div className='add-form'>
          <Form
            name="addMeeting"
            layout="vertical"
            autoComplete="off"
            className='add-meeting-form'
            onFinish={this.submit}
            ref={this.formRef}
          >
            <Form.Item
              name="time"
              label="送餐时间"
              rules={[
                {
                  required: true,
                  message: '请选择送餐时间',
                },
              ]}
            >
              <Select
                placeholder='请选择送餐时间'
                style={{ width: '100%' }}
                options={[
                  {
                    value: 1,
                    label: '09:00-10:00',
                    disabled: this.disabledTime(9)
                  },
                  {
                    value: 2,
                    label: '12:00-13:00',
                    disabled: this.disabledTime(12)
                  },
                  {
                    value: 3,
                    label: '19:00-20:00',
                    disabled: this.disabledTime(19)
                  },
                ]}
              />
              {/* <TimePicker
                placeholder='请选择送餐时间'
                format='HH:mm'
                disabledTime={this.disabledTime}
                showNow={false}
                style={{ width: '100%' }}
              /> */}
            </Form.Item>
            <Form.Item
              name="reason"
              label="订餐事由"
              rules={[
                { required: true, message: '请输入订餐事由' },
              ]}
            >
              <Input placeholder='请输入订餐事由' maxLength={50} />
            </Form.Item>
            <Form.Item
              name="standard"
              label="餐标"
              rules={[
                { required: true, message: '请选择餐标' },
              ]}
            >
              <Select
                placeholder='请选择餐标'
                style={{ width: '100%' }}
                options={[
                  {
                    value: 30,
                    label: '30元/人',
                  },
                  {
                    value: 50,
                    label: '50元/人',
                  },
                  {
                    value: 100,
                    label: '100元/人',
                  },
                ]}
              />
            </Form.Item>
            <Form.Item
              name="location"
              label="配送区域"
              rules={[
                { required: true, message: '请选择配送区域' },
              ]}
            >
              <Select
                placeholder='请选择配送区域'
                style={{ width: '100%' }}
                options={[
                  {
                    value: 1,
                    label: '7层东侧茶水间',
                  },
                  {
                    value: 2,
                    label: '8层西侧吧台',
                  },
                  {
                    value: 3,
                    label: '9层东侧吧台',
                  },
                  {
                    value: 4,
                    label: '10层西侧吧台',
                  },
                  {
                    value: 5,
                    label: '11层东侧吧台',
                  },
                  {
                    value: 6,
                    label: '东升大厦',
                  },
                ]}
              />
              {/* <Input placeholder='请输入配送区域' maxLength={50} /> */}
            </Form.Item>
            <Form.Item
              name="number"
              label="配餐数量"
              rules={[
                { required: true, message: '请输入配餐数量' },
              ]}
            >
              <InputNumber placeholder='请输入配餐数量' min={1} max={50} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item>
              <div className='add-form-btns'>
                <Button onClick={() => this.props.onClose()}>取消</Button>
                <Button type="primary" htmlType="submit" color='#F4A35F'>提交</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }
}